import { HttpParameterCodec } from '@angular/common/http';

export class HttpParamEncoderService implements HttpParameterCodec {

  encodeKey(key: string): string {
    return this.customEncoding(key);
  }

  encodeValue(value: string): string {
    return this.customEncoding(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }

  private customEncoding(value: string): string {
    return encodeURIComponent(value)
      .replace(/%40/gi, '@')
      .replace(/%3A/gi, ':')
      .replace(/%24/gi, '$')
      .replace(/%2C/gi, ',')
      .replace(/%3B/gi, ';')
      .replace(/%3D/gi, '=')
      .replace(/%3F/gi, '?')
      .replace(/%2F/gi, '/');
  }
}
